import { connect } from 'react-redux';
import mapProfileToProps from 'profile/containers/map_profile_to_props';
import ClientStats from 'profile/components/client_stats';

export default connect(mapProfileToProps)(ClientStats);



// WEBPACK FOOTER //
// ./profile/containers/client_stats.js